export const LEVELS = Object.freeze({
  PORTFOLIO: "portfolio",
  ALLOCATION_POINT: "aansluiting",
})

export const GRANULARITY = Object.freeze({
  DAY: "day",
  QUARTER: "quarter",
})

export const LINE_GRANULARITY = Object.freeze({
  MONTH: "month",
  QUARTER: "quarter",
})

export const CATEGORY = Object.freeze({
  MARKET: "markt",
  SERVICE_FEE: "vergoeding",
  TAX: "belasting",
})

export const INVOICE_CATEGORIES = Object.freeze([
  Object.freeze({ key: CATEGORY.MARKET, label: "Marktresultaten" }),
  Object.freeze({ key: CATEGORY.SERVICE_FEE, label: "Vergoeding diensten" }),
  Object.freeze({
    key: CATEGORY.TAX,
    label: "Belasting en overheidsheffingen",
  }),
])

export const MARKET_FIELDS = Object.freeze([
  "DAY_AHEAD_TOTAL_RESULT",
  "INTRADAY_TOTAL_RESULT",
  "ALLOCATION_POINT_IMBALANCE_TOTAL_RESULT",
  "PORTFOLIO_IMBALANCE_TOTAL_RESULT",
  "PORTFOLIO_BENEFIT_REPOWERED",
  "FCR_RESULT",
  "AFRR_RESULT",
])

export const HISTORY_MONTHS_BACK = 12
export const DEFAULT_DETAIL_ROW_LIMIT = 5

export const GRANULARITY_OPTIONS = Object.freeze([
  Object.freeze({ value: GRANULARITY.DAY, label: "Per dag" }),
  Object.freeze({ value: GRANULARITY.QUARTER, label: "Per kwartier" }),
])
